import { resolveDefaultRoleNameKey } from "@frontend-shared/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

// NOTE: Only the `useTranslation` wiring is per-platform. Which names count as
// default roles, how they are normalized, and the key each maps to live in
// `@frontend-shared/utils` so this and mobile's identical hook cannot drift.
export const useTranslateRoleName = (): ((name: string) => string) => {
  const { t } = useTranslation("settings");

  return useCallback(
    (name: string): string => {
      const translationKey = resolveDefaultRoleNameKey(name);

      return translationKey ? t(translationKey) : name;
    },
    [t],
  );
};
